// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.add-category-container {
    max-width: 400px;
    margin: 50px auto;
    padding: 30px;
    background: #fff;
    border-radius: 15px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
    text-align: center;
  }
  
  /* Heading */
  .add-category-container h2 {
    margin-bottom: 20px;
    color: #333;
  }
  
  /* Text Input */
  .add-category-container input[type="text"] {
    width: 100%;
    padding: 12px 16px;
    margin-bottom: 20px;
    border-radius: 8px;
    border: 1px solid #ccc;
    font-size: 15px;
    box-sizing: border-box;
    outline: none;
    transition: all 0.2s ease-in-out;
  }
  
  .add-category-container input[type="text"]::placeholder {
    color: #aaa;
  }
  
  .add-category-container input[type="text"]:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 6px rgba(59, 130, 246, 0.3);
    background-color: #fff;
  }
  
  /* Image Upload Box */
  .image-upload-box {
    position: relative;
    width: 100%;
    height: 150px;
    border: 2px dashed #aaa;
    border-radius: 10px;
    margin-bottom: 20px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  
  .image-upload-box span {
    color: #888;
    font-size: 14px;
  }
  
  .image-upload-box input[type="file"] {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  
  .preview-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  /* Buttons */
  .add-category-container button,
  .add-btn {
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 12px;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
  }
  
  .add-category-container button {
    color: #fff;
    background: linear-gradient(90deg, #4caf50, #45a049);
  }
  
  .add-category-container button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
  
  /* Header Bar (Search + Add Button) */
  .header-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
  }
  
  /* Search Bar */
  .search-bar {
    padding: 8px 16px;
    border-radius: 12px;
    border: 1px solid #0f212e;
    font-size: 0.95rem;
    width: 250px;
    background-color: #0f212e;
    color: white;
    outline: none;
    transition: all 0.2s ease-in-out;
  }
  
  .search-bar:focus {
    /* border-color: #3b82f6; */
    box-shadow: 0 0 6px rgba(59, 130, 246, 0.4);
    /* background-color: #fff; */
  }
  
  /* Add Button in Header */
  .add-btn {
    background-color: #3b82f6;
    color: #fff;
    font-weight: 500;
  }
  
  .add-btn:hover {
    background-color: #2563eb;
    transform: scale(1.05);
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Stock/AddStock/AddStock.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;EACpB;;EAEA,YAAY;EACZ;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA,eAAe;EACf;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,2CAA2C;IAC3C,sBAAsB;EACxB;;EAEA,qBAAqB;EACrB;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA,YAAY;EACZ;;IAEE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,oDAAoD;EACtD;;EAEA;IACE,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA,qCAAqC;EACrC;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA,eAAe;EACf;IACE,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,2CAA2C;IAC3C,4BAA4B;EAC9B;;EAEA,yBAAyB;EACzB;IACE,yBAAyB;IACzB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB","sourcesContent":["/* Container */\n.add-category-container {\n    max-width: 400px;\n    margin: 50px auto;\n    padding: 30px;\n    background: #fff;\n    border-radius: 15px;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n    text-align: center;\n  }\n  \n  /* Heading */\n  .add-category-container h2 {\n    margin-bottom: 20px;\n    color: #333;\n  }\n  \n  /* Text Input */\n  .add-category-container input[type=\"text\"] {\n    width: 100%;\n    padding: 12px 16px;\n    margin-bottom: 20px;\n    border-radius: 8px;\n    border: 1px solid #ccc;\n    font-size: 15px;\n    box-sizing: border-box;\n    outline: none;\n    transition: all 0.2s ease-in-out;\n  }\n  \n  .add-category-container input[type=\"text\"]::placeholder {\n    color: #aaa;\n  }\n  \n  .add-category-container input[type=\"text\"]:focus {\n    border-color: #3b82f6;\n    box-shadow: 0 0 6px rgba(59, 130, 246, 0.3);\n    background-color: #fff;\n  }\n  \n  /* Image Upload Box */\n  .image-upload-box {\n    position: relative;\n    width: 100%;\n    height: 150px;\n    border: 2px dashed #aaa;\n    border-radius: 10px;\n    margin-bottom: 20px;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n  }\n  \n  .image-upload-box span {\n    color: #888;\n    font-size: 14px;\n  }\n  \n  .image-upload-box input[type=\"file\"] {\n    position: absolute;\n    opacity: 0;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n  }\n  \n  .preview-image {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n  \n  /* Buttons */\n  .add-category-container button,\n  .add-btn {\n    padding: 8px 16px;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 12px;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease-in-out;\n  }\n  \n  .add-category-container button {\n    color: #fff;\n    background: linear-gradient(90deg, #4caf50, #45a049);\n  }\n  \n  .add-category-container button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  }\n  \n  /* Header Bar (Search + Add Button) */\n  .header-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 1rem;\n  }\n  \n  /* Search Bar */\n  .search-bar {\n    padding: 8px 16px;\n    border-radius: 12px;\n    border: 1px solid #0f212e;\n    font-size: 0.95rem;\n    width: 250px;\n    background-color: #0f212e;\n    color: white;\n    outline: none;\n    transition: all 0.2s ease-in-out;\n  }\n  \n  .search-bar:focus {\n    /* border-color: #3b82f6; */\n    box-shadow: 0 0 6px rgba(59, 130, 246, 0.4);\n    /* background-color: #fff; */\n  }\n  \n  /* Add Button in Header */\n  .add-btn {\n    background-color: #3b82f6;\n    color: #fff;\n    font-weight: 500;\n  }\n  \n  .add-btn:hover {\n    background-color: #2563eb;\n    transform: scale(1.05);\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
